import { useQuery } from 'react-query';
import { REACT_QUERY_NAMES as RQN } from 'newJs/config';
import { useQuotaStore } from 'state/quotaState';

const useQuota = (MAPI) => {
    const { fetch, v1 } = MAPI;
    const setUserQuota = useQuotaStore((state) => state.setUserQuota);

    return useQuery(
        [RQN.get('USER_QUOTA_INFO')],
        async () => await fetch({ url: v1.quota() }),
        {
            onSuccess: (data) => {
                setUserQuota(data);
            },
            onError: (err) => {
                if (err?.status === 401) {
                    console.error('Quota block gets unauthorized request!');
                }
            }
        }
    );
};

export default useQuota;